import styled, {css} from 'styled-components';
import colors from '../../theme/constants/colors';
import typography from '../../theme/typography';
import {StyledBarProps, StyledRangeProps} from './typings';

const thumbSize = '30px';

const thumbStyling = css`
  appearance: none;
  background-color: ${colors.white};
  border: 2px solid ${colors.red100};
  border-radius: 50%;
  box-shadow: none;
  cursor: pointer;
  height: ${thumbSize};
  width: ${thumbSize};
  pointer-events: all;
  position: relative;
  box-sizing: border-box;
`;

const Thumb = styled.input`
  appearance: none;
  -webkit-tap-highlight-color: transparent;
  pointer-events: none;
  position: absolute;
  height: 0;
  width: calc(100% - ${thumbSize});
  outline: none;

  &::-webkit-slider-thumb {
    ${thumbStyling}
  }

  &::-moz-range-thumb {
    ${thumbStyling}
  }
`;

export const StyledRightThumb = styled(Thumb)`
  z-index: 3;
`;

export const StyledLeftThumb = styled(Thumb)`
  z-index: 4;
  left: 30px;
`;

export const StyledTrack = styled.div`
  background-color: ${colors.grey25};
  width: 100%;
  z-index: 1;
`;

export const StyledRange = styled.div<StyledRangeProps>`
  background-color: ${colors.red100};
  z-index: 2;
  width: calc(${(props) => props.$rangeWidth}% + 15px);
  left: ${(props) => props.$rangeLeftMargin}%;
`;

export const StyledSlider = styled.div`
  position: relative;
  width: calc(100% - 60px);
  left: 30px;

  ${StyledTrack},
  ${StyledRange} {
    border-radius: 2px;
    height: 2px;
    position: absolute;
  }
`;

export const StyledBarChart = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: repeat(100, 1fr);
  height: 50px;
  column-gap: 2px;
  padding: 0 30px;
`;

export const StyledBar = styled.div<StyledBarProps>`
  background: ${(props) => (props.$active === true ? colors.red25 : colors.grey25)};
  border-radius: 2px 2px 0 0;
  grid-row: ${(props) =>
    `${props.$barHeight === 0 ? 100 : 101 - props.$barHeight} / span ${
      props.$barHeight === 0 ? 1 : props.$barHeight
    }`};
  grid-column: span ${(props) => props.$barWidth};
  opacity: ${(props) => (props.$barHeight === 0 ? 0 : 1)};
`;

export const StyledNumbers = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 15px 30px 0;

  > span {
    ${typography.Body3}
  }
`;

const StyledRangeSlider = styled.div`
  margin-top: 20px;
  position: relative;
`;

export default StyledRangeSlider;
